<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">
      <md-card class="search-area">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>search</md-icon>검색 조건
          </h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>교우명</th>
              <td>
                <input v-focus type="text" v-model="query.memberHnm" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>교우번호</th>
              <td>
                <input type="text" v-model="query.memberNo" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>교수전공학과</th>
              <td>
                <input type="text" v-model="query.profMajorClassNm" v-on:keyup.enter="searchQuery"/>
              </td>
              <th>작고여부</th>
              <td>
                <label>
                  <input type="radio" value="2" v-model="query.status" name="status">Y
                </label>
                <label>
                  <input type="radio" value="1" v-model="query.status" name="status">N
                </label>
              </td>
              <th>퇴임일</th>
              <td>
                <input type="text" v-model="query.expireDate" v-mask="'####-##-##'">
              </td>
            </tr>
            <tr>
              <th>교원구분</th>
              <td colspan="9">
                <label v-for="item in staffTypeList" v-bind:key="item.code"><input type="checkbox" :key="item.code" :value="item.code" v-model="checkedStaffTypeList">{{item.codeNm}}</label>
              </td>
            </tr>
          </table>
        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="searchQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-default md-sm" @click="clearQuery">
            <md-icon>clear</md-icon>초기화
          </md-button>
          <md-button class="md-success md-sm" :disabled="this.pagination.total === 0" @click="downloadExcel" v-exel-btn="[5,3]">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
      </md-card>

      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>assignment</md-icon>검색 결과
          </h4>
        </md-card-header>
        <md-card-content>
          <div class="table-header-info">
            <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
            <div>
              <select v-model="pagination.perPage" name="pages" @change="perPageChange">
                <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
          </div>

          <grid ref="StaffList"
                :data="gridProps.data"
                :columns="gridProps.columns"
                :options="gridProps.options"
                :theme="gridProps.theme"
                :rowHeaders="gridProps.rowHeaders"
                :columnOptions="gridProps.columnOptions"
                :language="gridProps.lang"
                @click="setExecutive"
                @response="response"
          ></grid>

        </md-card-content>
      </md-card>
      <md-card class="search-area" v-show="isEdit">
        <md-card-header md-alignment="space-between">
          <h4 class="title">
            <md-icon>edit</md-icon>교원 정보
          </h4>
        </md-card-header>

        <md-card-content>
          <table class="flex-table">
            <tr>
              <th>교우번호</th>
              <td>
                <div class="inline-flex">
                  <input type="text" v-model="memberInfo.memberNo" disabled>
                </div>
              </td>
              <th>작고여부</th>
              <td>

                <label>
                  <input type="radio" v-model="memberInfo.statusCd" value="2" />Y
                </label>
                <label>
                  <input type="radio" v-model="memberInfo.statusCd"  value="1" />N
                </label>
              </td>
              <th>교수전공학과</th>
              <td>
                <input type="text" v-model="memberInfo.profMajorClassNm">
              </td>
              <th>퇴임일</th>
              <td>
                <input type="text" v-mask="'####-##-##'" v-model="memberInfo.expireDate">
              </td>
            </tr>
          </table>

        </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="saveExecutive" :disabled="!memberInfo.memberNo">
            <md-icon>check</md-icon>저장
          </md-button>
        </md-card-actions>
      </md-card>
    </div>
    <div id="scrollTargetBox"></div>
  </div>
</template>

<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import axios from "axios";
import Swal from "sweetalert2";
import formatter from "@/kuaa/kuaa-formatter";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";
import session from "@/kuaa/kuaa-sessions";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  components: {
    grid: Grid
  },

  created() {
    this.queryStaffTypes();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },

  data() {
    return {
      formatter,
      isEdit : false,
      gridProps: {},
      pagination: {
        perPage: 20,
        page: 1,
        perPageOptions: [20, 50, 100, 200, 500],
        total: 0
      },

      query: {
        printingGb: 'Y',
        memberHnm: null,
        memberNo: null,
        classMajor: null,
        status: null,
        expireDate: null,
        staffCd : null
      },
      memberInfo : {
        memberNo : null,
        status : null,
        profMajorClassNm : null,
        expireDate : null
      },
      staffTypeList : [],
      checkedStaffTypeList : []
    }
  },
  methods: {

    /**
     * 교원 여부 - 공통코드 조회 세팅
     */
    queryStaffTypes() {
      kuaaFnc.fncStaffTypes(null,res => {
        this.staffTypeList = res.data.data.contents;
      });
    },

    /**
     * 검색 실행
     */
    searchQuery() {
      this.query.staffCd = this.checkedStaffTypeList;
      this.$refs.StaffList.invoke("readData", 1, this.query);
      //this.$refs.StaffList.invoke("readData", this.$refs.StaffList.invoke("getPagination")._currentPage, this.query);
    },
    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_MEMBER_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.StaffList;
      this.gridProps['columns']= [
          {header: '교우번호', name: 'memberNo', align : 'center', width:70, sortable: true},
          {header: '교우명', name: 'memberHnm', width:100, sortable: true},
          {header: '교원구분', name: 'staffCdNm', width:100, sortable: true},
          {header: '성별', name: 'sex', align:"center", width:50, sortable: true},
          {header: '생년월일', name: 'birthday', align:"center", width:100, sortable: true,
            formatter(value) {
              return (value.value && value.value.length == 8) ? formatter.getDateFormat(value.value) : value.value;
            }
          },
          {header: '전공학과', name: 'profMajorClassNm', width:120, sortable: true},
          {header: '퇴임일', name: 'expireDate', align : 'center', width:80, sortable: true,
            formatter(value) {
              return formatter.getDateFormat(value.value);
            }
          },
          {header: '발송지우편번호', name: 'zipcd', align : 'center', width:120, sortable: true},
          {header: '발송지주소1', name: 'address1', width:250, sortable: true},
          {header: '발송지주소2', name: 'address2', width:250, sortable: true},
          {header: '자택전화', name: 'homeTel', align : 'center', width:100, sortable: true},
          {header: '핸드폰', name: 'cellular', align : 'center', width:100, sortable: true},
          {header: '이메일', name: 'eMail', width:150, sortable: true},
          {header: '작고여부', name: 'statusCdNm', align : 'center', width:80, sortable: true},
          {header: '발송구분', name: 'postplaceNm', align:"center", width:80, sortable: true},
          {header: '미발송사유', name: 'nonpostGbNm', align:"center", width:90, sortable: true}
        ];
      this.gridProps['columnOptions'].frozenCount = 3;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.StaffList, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      //this.$refs.StaffList.invoke("refreshLayout");
      this.clearMemberInfo();
    },
    /**
     * 검색조건 초기화
     */
    clearQuery() {
      this.query = {
        printingGb: 'Y',  // 화면명
        memberHnm: null,
        memberNo: null,
        classMajor: null,
        status: null,
        expireDate: null,
        staffCd : null
      };
    },
    clearMemberInfo(){
      this.isEdit = false;
      this.memberInfo = {
        memberNo : null,
        status : null,
        profMajorClassNm : null,
        expireDate : null
      }
    },
    setExecutive(e){
      if(e.instance.getRow(e.rowKey) != null) {
        this.isEdit = true;
        this.memberInfo = e.instance.getRow(e.rowKey);
        kuaaFnc.scrollTo('scrollTargetBox');
      }
    },
    saveExecutive(){
      let modalOptions = kuaaFnc.getSwalModaloptions('confirm',{
        html: "저장 하시겠습니까?",
      });

      Swal.fire(modalOptions).then(result => {
        if (result.value) {
          let params = JSON.parse(JSON.stringify(this.memberInfo));
          params.expireDate = kuaaFnc.cleanDateFormatter(params.expireDate);
          kuaaApi.sendServer(
            URL_CONST.SAVE_MEMBER,
            params,
            "post",
            response => {
              if (response.data.success){
                modalOptions.html = `저장 되었습니다.`;
                this.$refs.StaffList.invoke("readData", this.$refs.StaffList.invoke("getPagination")._currentPage, this.query);
              } else {
                modalOptions.html = `저장 실패 하였습니다.`;
                Swal.fire(modalOptions);
              }
            }
          );
        }
      });
    },
    downloadExcel() {
      if(this.pagination.total > 100000){
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드 대상은 100,000건 이하여야 합니다.");
        return false;
      }

      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '교원관리';
      kuaaApi.requestFileDownload(
          URL_CONST.MEMBER_EXCEL_DOWNLOAD,
          this.query,
          '교원관리.xlsx',
          response => {
          }
      );
    }
  }
}
</script>

<style scoped>

</style>